const Events = () => {

  return <div>Event</div>
};

export default Events;
